export default "__VITE_ASSET__q$QkMeqD__"